<template>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.8291 20.6366C6.98716 13.0551 18.2354 13.1217 21.2512 20.8365" class="navbar_hoverEffect" stroke-width="2"/>
        <circle cx="12.5" cy="12.5" r="11.5" class="navbar_hoverEffect_second" stroke-width="2"/>
        <circle cx="12.5" cy="10.5" r="4.5" class="navbar_hoverEffect" stroke-width="2"/>
    </svg>
</template>

<script>
export default {
  name: 'ProfileIcon'
}
</script>

<style scoped>
    path {
        stroke: var(--nav-menu-new-icon);
    }
    circle {
        stroke: var(--nav-menu-new-icon);
    }
</style>
